import React from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerHeader,
  DrawerOverlay,
  Button,
  Input,
  useToast,
  VStack,
  HStack,
} from '@chakra-ui/react';
import AdminDrawerContent from '../layout/AdminDrawerContent';
import { AdminField, useAdminFormFieldProps } from '../layout/AdminFormControls';

const FuelTypeEditModal = ({ isOpen, onClose, fuelType, isNew, onCreate, onUpdate }) => {
  const [formData, setFormData] = React.useState({});
  const toast = useToast();
  const { fieldProps } = useAdminFormFieldProps();

  React.useEffect(() => {
    setFormData({
      id: fuelType?.id || null,
      type: fuelType?.type || '',
      enabled: fuelType?.enabled || true,
    });
  }, [fuelType, isNew]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value.toUpperCase() });
  };

  const handleSave = () => {
    try {
      if (isNew) {
        onCreate(formData);
        toast({
          title: 'Tipo de combustible creado',
          description: 'El nuevo tipo de combustible se ha guardado exitosamente.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      } else {
        onUpdate(formData);
        toast({
          title: 'Tipo de combustible actualizado',
          description: 'Los cambios se han guardado exitosamente.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      }
      onClose();
    } catch (error) {
      toast({
        title: 'Error al guardar tipo de combustible',
        description: error.message || 'No se pudo completar la operación.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} closeOnOverlayClick={false}>
      <DrawerOverlay />
      <AdminDrawerContent>
        <DrawerCloseButton />
        <DrawerHeader fontSize="lg" fontWeight="bold">
          {isNew ? 'Nuevo tipo de combustible' : 'Editar tipo de combustible'}
        </DrawerHeader>
        <DrawerBody>
          <VStack spacing={3} align="stretch">
            <AdminField label="Nombre" isRequired>
              <Input
                name="type"
                value={formData.type}
                onChange={handleChange}
                placeholder="Tipo de combustible"
                {...fieldProps}
              />
            </AdminField>
          </VStack>
        </DrawerBody>
        <HStack justify="flex-end" p={4} borderTopWidth="1px" borderColor="gray.100">
          <Button size="sm" variant="ghost" onClick={onClose}>
            Cancelar
          </Button>
          <Button size="sm" variant="adminPrimary" onClick={handleSave}>
            Guardar
          </Button>
        </HStack>
      </AdminDrawerContent>
    </Drawer>
  );
};

export default FuelTypeEditModal;
